/**
 * 健康指标单位（与 HealthThresholdModal 对齐）
 * @param {number} type 指标类型
 * @param {object} vm Vue 组件实例（用于 $t）
 */
export function getHealthUnit (type, vm) {
  const t = vm && vm.$t ? vm.$t.bind(vm) : (k) => k
  const map = {
    0: 'bpm',
    1: '°C',
    2: 'mmHg',
    3: '%',
    4: 'mmol/L',
    6: t('xiao-shi') || '小时'
  }
  return map[type] != null ? map[type] : ''
}

export function formatValueWithUnit (value, type, vm) {
  if (value === null || value === undefined || value === '' || value === '--') {
    return '--'
  }
  const unit = getHealthUnit(type, vm)
  if (type === 6) {
    return `${value}${unit}`
  }
  return unit ? `${value} ${unit}` : String(value)
}

/** 将日期范围规范为带时分秒的查询参数 */
export function normalizeScopeDateRange (scopeDate) {
  if (!scopeDate || scopeDate.length !== 2 || !scopeDate[0]) {
    return {}
  }
  const toDateStr = (val) => {
    if (val instanceof Date) {
      const y = val.getFullYear()
      const m = val.getMonth() + 1
      const d = val.getDate()
      return `${y}-${m}-${d}`
    }
    return String(val).trim()
  }
  const start = toDateStr(scopeDate[0])
  const end = toDateStr(scopeDate[1] || scopeDate[0])
  const startTime = /^\d{4}-\d{1,2}-\d{1,2}$/.test(start) ? `${start} 00:00:00` : start
  const endTime = /^\d{4}-\d{1,2}-\d{1,2}$/.test(end) ? `${end} 23:59:59` : end
  return { startTime, endTime }
}



// WEBPACK FOOTER //
// ./src/utils/healthUnit.js